import { KnownSortOrder } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useHasUIFeatures } from '../../../core/permissions/has-permissions.hook';
import { TableComponents } from '../../../ui/components/pure/list-table/list-table-cells.component';
import { ListTable } from '../../../ui/components/pure/list-table/list-table.component';
import { initTable } from '../../../ui/components/pure/list-table/list-table.init';
import { pinned, WRAP_ANYWHERE } from '../../../ui/components/pure/list-table/list-table-column-styles';
import { Courier } from './models/courier.model';

const tb = initTable<Courier>();
tb.styles({
  table: { tableLayout: 'fixed' }
});

tb.column('IMAGE', TableComponents.TenantLogo, {
  name: () => '',
  imageURL(row) {
    return row.carrier.image;
  }
}).options({
  headerStyles: pinned('72px')
});
tb.column('NAME', TableComponents.Text, {
  value: ':carrier.name'
}).options({
  styles: WRAP_ANYWHERE
});
tb.column('COURIER NAME', TableComponents.Text, {
  value: getCourierName
}).options({
  styles: WRAP_ANYWHERE
});
tb.column('CARRIER ID', TableComponents.Text, {
  value: ':carrier.id',
  noUppercase: () => true
}).options({
  styles: WRAP_ANYWHERE
});
tb.column('COURIER ID', TableComponents.Text, {
  value: ':id',
  noUppercase: () => true
}).options({
  styles: WRAP_ANYWHERE
});

tb.rowStyles({
  td: (row) => ({
    color: row.canMakeDeliveries ? undefined : '#ADADAD',
    textDecoration: row.canMakeDeliveries ? undefined : 'line-through'
  })
});

export interface CourierLoginTestingTableProps {
  couriers: Courier[];
  isLoading: boolean;
  isError: boolean;
  errorMessage?: string;
}

export function CourierLoginTestingTable(props: CourierLoginTestingTableProps) {
  const hasExperimentalFeatureFlag = useHasUIFeatures(['experimental']);

  tb.addPredicate('CARRIER ID', () => hasExperimentalFeatureFlag.hasAllFeatures);
  tb.addPredicate('COURIER ID', () => hasExperimentalFeatureFlag.hasAllFeatures);

  return (
    <ListTable
      uniqueKey={'id'}
      hasError={props.isError}
      errorMessage={props.errorMessage}
      onSort={() => {}}
      rows={props.couriers}
      sortData={{
        sortBy: '',
        sortOrder: KnownSortOrder.Asc
      }}
      table={tb}
      isLoading={props.isLoading}
    />
  );
}

function getCourierName(courier: Courier) {
  const firstName = courier.firstName;
  const lastName = courier.lastName;

  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  return firstName || lastName || '';
}
